import { connect } from 'react-redux';
import DownloadAppPopup  from './download_app_popup';

const mapStateToProps = ({ chat, voipChat: { order }, application: { dynamicConfig } }) => ({
  ...chat,
  ...order,
  url: dynamicConfig?.url
});

export default connect(
  mapStateToProps,
  {}
)(DownloadAppPopup);
